// extracted by mini-css-extract-plugin
export default {"userMenu":"user-menu_userMenu__+IaB2","icon":"user-menu_icon__lGiyO","username":"user-menu_username__7MY5b","userMenuDrawer":"user-menu_userMenuDrawer__Ve3vR"};